import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { CODE_ERREUR_FONCTIONNELLE_RHN } from '../ErreurFonctionnelle.connected';
import { ErreurFonctionnelleAvecPhoto } from '../../../components/erreurFonctionnelleAvecPhoto/ErreurFonctionnelleAvecPhoto';
import { appParams } from '../../../utils/parametersHelper';

interface IErreurFonctionnelleCustom {
    codeErreurRHN: string;
    versionTexteErreurPaiementEnAttente?: string;
    revenirJourSemaineErreurPaiementEnAttente?: string;
}

export enum VERSION_TEXTE_ERREUR_PAIEMENT_EN_ATTENTE {
    DATE_RAPPEL_IMMINENTE = 'DATE_RAPPEL_IMMINENTE',
    DATE_RAPPEL_ELOIGNEE = 'DATE_RAPPEL_ELOIGNEE'
}

export const ErreurFonctionnelleCustom: React.FC<
    IErreurFonctionnelleCustom
> = ({
    codeErreurRHN,
    versionTexteErreurPaiementEnAttente,
    revenirJourSemaineErreurPaiementEnAttente
}) => {
    const [t] = useTranslation(['ErreurFonctionnelle']);

    const getTitle = () => {
        switch (codeErreurRHN) {
            case CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_CALCUL_OFFRE:
                return t('erreurTarifTitre');
            case CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_PAIEMENT_EN_ATTENTE:
                return t(
                    versionTexteErreurPaiementEnAttente ===
                        VERSION_TEXTE_ERREUR_PAIEMENT_EN_ATTENTE.DATE_RAPPEL_ELOIGNEE
                        ? 'erreurPaiementEnAttenteDateRappelEloigneeTitre'
                        : 'erreurPaiementEnAttenteDateRappelImminenteTitre'
                );
        }
    };

    const getDescriptionChildren = () => {
        switch (codeErreurRHN) {
            case CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_CALCUL_OFFRE:
                return (
                    <Trans
                        i18nKey={'ErreurFonctionnelle:erreurTarifDescription'}
                    />
                );
            case CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_PAIEMENT_EN_ATTENTE:
                return (
                    <Trans
                        i18nKey={
                            versionTexteErreurPaiementEnAttente ===
                            VERSION_TEXTE_ERREUR_PAIEMENT_EN_ATTENTE.DATE_RAPPEL_ELOIGNEE
                                ? 'ErreurFonctionnelle:erreurPaiementEnAttenteDateRappelEloigneeDescription'
                                : 'ErreurFonctionnelle:erreurPaiementEnAttenteDateRappelImminenteDescription'
                        }
                        values={{
                            jour: t(revenirJourSemaineErreurPaiementEnAttente)
                        }}
                    />
                );
        }
    };

    return (
        <ErreurFonctionnelleAvecPhoto
            title={getTitle()}
            descriptionChildren={getDescriptionChildren()}
            pathImageMobile={`${appParams.staticSpaUrl}/images/page_deeplink_mobile.jpg`}
            pathImageDesktop={`${appParams.staticSpaUrl}/images/page_deeplink_desktop.jpg`}
        />
    );
};
